import {h} from 'preact'
import constants from "../constants";
import DropdownResize from "./DropdownResize";
import {useState} from "preact/hooks";
import util from "../util";
import LogoTopRight from "./svg/LogoTopRight";
import LogoBottomMiddle from "./svg/LogoBottomMiddle";
import LogoBottomLeft from "./svg/LogoBottomLeft";
import LogoTopMiddle from "./svg/LogoTopMiddle";
import LogoTopLeft from "./svg/LogoTopLeft";
import LogoBottomRight from "./svg/LogoBottomRight";
import aiService from "../service/aiService";
import store from "../store";
import imageService from "../service/imageService";

const LogoPlacementIcons = [
  {key: "top-left", name: "Top Left", comp: <LogoTopLeft />},
  {key: "top-middle", name: "Top Middle", comp: <LogoTopMiddle />},
  {key: "top-right", name: "Top Right", comp: <LogoTopRight />},
  {key: "bottom-left", name: "Bottom Left", comp: <LogoBottomLeft />},
  {key: "bottom-middle", name: "Bottom Middle", comp: <LogoBottomMiddle />},
  {key: "bottom-right", name: "Bottom Right", comp: <LogoBottomRight />},
]

const PhotoPlacementIcons = [
  {key: "top", name: "Top", path: `${constants.appPrefix}/image/ai/Photos-Top.svg`},
  {key: "left", name: "Left", path: `${constants.appPrefix}/image/ai/Photos-Left.svg`},
  {key: "bottom", name: "Bottom", path: `${constants.appPrefix}/image/ai/Photos-Bottom.svg`},
  {key: "right", name: "Right", path: `${constants.appPrefix}/image/ai/Photos-Right.svg`},
  {key: "next-to", name: "Next to Item", path: `${constants.appPrefix}/image/ai/Photos-Next-to-Item.svg`}
]

const DataColumnsIcons = [
  {key: "one", name: "One Column", path: `${constants.appPrefix}/image/ai/Columns-One.svg`},
  {key: "two", name: "Two Columns", path: `${constants.appPrefix}/image/ai/Columns-Two.svg`},
  {key: "three", name: "Three Columns", path: `${constants.appPrefix}/image/ai/Columns-Three.svg`},
]

const BackgroundOptions = [
  {key: "chalkboard", name: "Chalkboard", path: `${constants.appPrefix}/image/ai/Chalkboard.png`},
  {key: "brick", name: "Brick", path: `${constants.appPrefix}/image/ai/Brick.png`},
  {key: "canvas", name: "Canvas", path: `${constants.appPrefix}/image/ai/Canvas.png`},
  {key: "parchment", name: "Parchment", path: `${constants.appPrefix}/image/ai/Parchment.png`},
  {key: "light-wood", name: "Light Wood", path: `${constants.appPrefix}/image/ai/LightWood.png`},
  {key: "dark-wood", name: "Dark Wood", path: `${constants.appPrefix}/image/ai/DarkWood.png`}
]

export default function AiMenuBuilder() {
  const [size, setSize] = useState("");
  const [name, setName] = useState("");
  const [dataColumns, setDataColumns] = useState("");
  const [logoSrc, setLogoSrc] = useState("");
  const [logoPlacement, setLogoPlacement] = useState("");
  const [logoUploading, setLogoUploading] = useState(false);
  const [photoPlacement, setPhotoPlacement] = useState("");
  const [themePrompt, setThemePrompt] = useState("")
  const [background, setBackground] = useState("");
  const [generating, setGenerating] = useState(false);

  function onSelectedSize(key: string) {
    setSize(util.getSize(key)?.label);
    document.body.click()
  }

  function generate() {
    const {designId} = store.getState();

    setGenerating(true);
    // aiService.generateMenu(designId, size, name, logoPlacement, logoSrc, background, themePrompt, photoPlacement,dataColumns).then(resp => {
    //   setGenerating(false);
    //   window.location.reload();
    // })
  }

  function onDataSourceChange() {

  }

  function onLogoChange(ev: any) {
    const file = ev.target.files[0];
    const {memberId, locationId} = store.getState();

    const formData = new FormData();
    formData.append("images", file, file.name);
    formData.append("locationId", locationId);

    setLogoUploading(true);
    imageService.uploadMemberImage(memberId, formData).then(resp => {
      setLogoUploading(false);
      setLogoSrc("https://timber.mhmcdn.com/" + resp.data[0].path);
    })
  }

  return <div className="aimb">
    <header className="main">
      <div className="back-group" style={{width: "auto"}}>
        <a className="logo">
          <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-icon"}/></svg>
        </a>
        <div className="timber-icon-ct">
          <svg className="timber-icon"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-timber-icon"}/></svg>
        </div>
        <div>
          <div className="design-label">Menu Mixer</div>
        </div>
      </div>
    </header>
    <aside>
      <div className={"scroller"}>
        <section className="half">
          <div>
            <label>Size</label>
            <div className="dropdown" style="position: relative;">
              <div className={"size-select dropdown-toggle"}>{size}</div>
              <DropdownResize embedded={true} onSelectedSize={onSelectedSize}/>
            </div>
          </div>
          <div>
            <label>Name</label>
            <input type={"text"} placeholder={"Name your design"} value={name} onChange={ev => setName((ev.target as HTMLInputElement).value)}/>
          </div>
        </section>

        <section className="half">
          <div>
            <label>Logo</label>

            {!logoSrc && <div className={"log-up upl"}>
              <input type="file" name="image" onChange={onLogoChange} accept="image/jpeg,image/png" className="input-file"/>
              <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M58.7192 27.2489C57.7371 20.0741 51.1898 14.9999 43.9877 15.8183C43.142 15.9274 42.3235 16.0911 41.5324 16.3366C35.7489 8.91628 25.0276 7.6068 17.6072 13.3903C13.4605 16.6367 11.0326 21.6018 11.0598 26.867V27.3035C2.95747 31.9958 0.174842 42.3624 4.83984 50.4648C7.868 55.7027 13.4605 58.9491 19.4896 58.9491H23.0088V54.1204H19.5987C12.8877 54.0659 7.51335 48.6097 7.56791 41.8987C7.5952 37.2064 10.3233 32.9506 14.5791 30.9864L16.2432 30.2771L16.0249 28.4765C15.9431 27.9582 15.9158 27.4399 15.9158 26.9215C15.9158 20.1832 21.3992 14.6998 28.1649 14.7271C32.4206 14.7271 36.3763 16.9641 38.5861 20.6197L39.7319 22.5566L41.7234 21.5472C45.9246 19.4466 51.0534 21.138 53.154 25.3393C53.6996 26.4305 53.9997 27.6581 54.0542 28.8858V30.4135L55.4456 31.0409C61.5292 33.8236 64.2027 41.0257 61.42 47.1093C59.4558 51.3378 55.2546 54.0931 50.5896 54.2023H47.0977V59.0309H50.535C59.8923 59.0309 67.4491 51.3923 67.4218 42.0351C67.4218 35.8969 64.0663 30.2498 58.7192 27.2762"
                  fill="#CFCFCF"/>
                <path
                  d="M36.54 28.8857L36.2127 28.531C35.176 27.6035 33.5937 27.6581 32.6116 28.6402L24.782 38.0247C23.8818 39.116 24.0455 40.7255 25.1367 41.5985C26.2279 42.4988 27.8648 42.3351 28.765 41.2166L31.9023 37.4518V56.3574C31.9023 57.776 33.0481 58.8945 34.4394 58.8945C35.8307 58.8945 36.9765 57.7487 36.9765 56.3574V37.2609L40.3321 41.2711C41.2869 42.2805 42.8692 42.3351 43.8785 41.3803C44.8334 40.48 44.9425 38.9795 44.1241 37.9429L36.5128 28.8584L36.54 28.8857Z"
                  fill="#CFCFCF"/>
              </svg>
              <label>
                {logoUploading ? "Uploading..." : "Upload"}
              </label>
            </div>}

            {!!logoSrc && <div className={"lge"}>
              <img src={logoSrc} alt={"Logo"} />
            </div>}
          </div>
          <div className={"log-place"}>
            <label>Logo Placement</label>
            <ul>
              {LogoPlacementIcons.map(it =>
                <li
                  key={it.key}
                  className={it.key === logoPlacement ? "sel" : ""}
                  onClick={() => setLogoPlacement(it.key)}>
                  {it.comp}
                  {it.name}
                </li>)}
            </ul>
          </div>
        </section>

        <section className={"full bg-ops"}>
          <label>Backgrounds</label>
          <ul>
            <li onClick={() => setBackground("plain")}>
              <div className={"plain img"}></div>
              Plain
            </li>
            {BackgroundOptions.map(it =>
              <li
                key={it.key}
                className={it.key === background ? "sel" : ""}
                onClick={() => setBackground(it.key)}>
                <img className={"img"} src={it.path} alt={it.name}/>
                {it.name}
              </li>)}
          </ul>
        </section>

        <section className={"full"}>
          <label>Theme Graphics</label>
          <textarea
            value={themePrompt}
            onChange={(ev) => setThemePrompt((ev.target as HTMLTextAreaElement).value) }
            placeholder={"Describe the kind of line art graphics you want here"}></textarea>
        </section>

        <section className={"full pho-ops"}>
          <label>Photo Placements</label>
          <ul>
            {PhotoPlacementIcons.map(it =>
              <li
                key={it.key}
                className={it.key === photoPlacement ? "sel" : ""}
                onClick={() => setPhotoPlacement(it.key)}>
                <img className={"img"} src={it.path} alt={it.name}/>
                {it.name}
              </li>)}
          </ul>
        </section>

        <section className={"full dat-ops"}>
          <label>Data</label>
          <div className={"ctn"}>
            <div className={"upl"}>
              <input type="file" name="image" onChange={onDataSourceChange} accept="image/jpeg,image/png" className="input-file"/>
              <label>Choose<br />Source</label>
            </div>

            <ul>
              {DataColumnsIcons.map(it =>
                <li
                  key={it.key}
                  className={it.key === dataColumns ? "sel" : ""}
                  onClick={() => setDataColumns(it.key)}>
                  <img className={"img"} src={it.path} alt={it.name}/>
                  {it.name}
                </li>)}
            </ul>
          </div>
        </section>
      </div>

      <footer>
        <button className={"btn primary lg"} onClick={generate}>
          {generating ? "Generating..." : "Generate"}
        </button>
      </footer>
    </aside>

    <section className={"main"}></section>
  </div>;
}
